import React, { useEffect, useState } from "react";
import { locationService } from "../../services/location.service";
import { IPriceSize } from "../../shared/interfaces/size";
import { tS } from "../../services/translation.service";
interface IProps {
  locationId: number | undefined;
  setSelectedSize: (size: IPriceSize) => void;
  onNextStep: () => void;
  isGerman: boolean;
  setSizeList: (sizeList: IPriceSize[]) => void;
  selectedLanguage: number;
}
export const ListingSizesStep = (props: IProps) => {
  const { locationId, setSelectedSize, onNextStep, isGerman, setSizeList, selectedLanguage } = props;
  const [locationSizes, setLocationSizes] = useState<IPriceSize[]>([]);

  const getSizes = (locationId: number) => {
    locationService.getPriceSizes(locationId).then((response) => {
      if (response) {
        setLocationSizes(response);
        setSizeList(response);
      }
    });
  };

  useEffect(() => {
    if (locationId) {
      getSizes(locationId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSelectPriceSize = (size: IPriceSize) => {
    setSelectedSize(size);
    onNextStep();
  };
  return (
    <div
      className="container"
      style={{
        padding: 30,
      }}
    >
      <p>{tS.gT(tS.P.SelectCompartmentSize, selectedLanguage)}</p>
      {locationSizes.map((size, index) => {
        return (
          <button
            key={index + size.sizeId.toString()}
            style={{ margin: 10 }}
            onClick={() => onSelectPriceSize(size)}
          >
            {size.sizeName} - {size.height}cm x {size.width}cm x {size.depth}cm
          </button>
        );
      })}
    </div>
  );
};
